import ApiService from './api'

class WarehouseTransferService {
  /**
   * Get all warehouse transfer notes
   * @param {Object} params - Query parameters for filtering and pagination
   * @returns {Promise} API response
   */
  async getAllTransferNotes(params = {}) {
    try {
      const response = await ApiService.get('/warehouse-transfer-notes', { params })
      return response.data
    } catch (error) {
      console.error('Error fetching warehouse transfer notes:', error)
      
      // Return mock data if API is not available
      if (error.message === 'Not found' || error.response?.status === 404) {
        console.warn('Warehouse transfer notes API not available, returning mock data')
        return {
          success: true,
          data: {
            transferNotes: [],
            pagination: {
              total: 0,
              page: 1,
              totalPages: 0
            }
          }
        }
      }
      throw error
    }
  }

  /**
   * Get warehouse transfer note by ID
   * @param {string} id - Transfer note ID
   * @returns {Promise} API response
   */
  async getTransferNoteById(id) {
    try {
      const response = await ApiService.get(`/warehouse-transfer-notes/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching warehouse transfer note:', error)
      throw error
    }
  }

  /**
   * Create a new warehouse transfer note
   * @param {Object} transferData - Transfer note data
   * @returns {Promise} API response
   */
  async createTransferNote(transferData) {
    try {
      const response = await ApiService.post('/warehouse-transfer-notes', transferData)
      
      // Handle case where API returns 200 but with validation errors
      if (response.data && response.data.success === false) {
        throw new Error(response.data.message || 'Creation failed')
      }
      
      return response.data
    } catch (error) {
      console.error('Error creating warehouse transfer note:', error)
      throw error
    }
  }

  /**
   * Update warehouse transfer note by ID
   * @param {string} id - Transfer note ID
   * @param {Object} updateData - Updated transfer note data
   * @returns {Promise} API response
   */
  async updateTransferNote(id, updateData) {
    try {
      const response = await ApiService.patch(`/warehouse-transfer-notes/${id}`, updateData)
      return response.data
    } catch (error) {
      console.error('Error updating warehouse transfer note:', error)
      throw error
    }
  }

  /**
   * Delete warehouse transfer note by ID
   * @param {string} id - Transfer note ID
   * @returns {Promise} API response
   */
  async deleteTransferNote(id) {
    try {
      const response = await ApiService.delete(`/warehouse-transfer-notes/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting warehouse transfer note:', error)
      throw error
    }
  }
}

export default new WarehouseTransferService()